export enum StatisticsTab {
  Names = 'names',
  MonitoredNames = 'monitored_names',
  Tags = 'tags',
  Entities = 'entities',
  Evidences = 'evidences',
}
